var __dsT = function (k, d) { var o = window.dsI18n || {}; return (o[k] != null) ? o[k] : d; };
/* De Sierkamer — inner-page interactivity (SEO toggles, product gallery, buy box,
   load more, recent bekeken, TOC scroll-spy, overlays). */
(function () {
  'use strict';
  if (window.__dsPagesInit) return;
  window.__dsPagesInit = true;

  /* SEO "Lees verder" + generic open/close toggles */
  document.addEventListener('click', function (e) {
    const t = e.target.closest('[data-ds-toggle]');
    if (t) {
      const sel = t.getAttribute('data-ds-toggle');
      const target = t.closest(sel) || document.querySelector(sel);
      if (target) {
        const open = target.classList.toggle('is-open');
        t.querySelectorAll('[data-ds-toggle-label]').forEach(function (el) {
          el.textContent = open ? (t.dataset.labelOpen || __dsT("read_less", 'Minder lezen')) : (t.dataset.labelClosed || __dsT("read_more", 'Lees verder'));
        });
      }
    }
    const overlayOpen = e.target.closest('[data-ds-overlay-open]');
    if (overlayOpen) {
      const ov = document.querySelector(overlayOpen.getAttribute('data-ds-overlay-open'));
      if (ov) {
        ov.classList.add('is-open');
        const vid = ov.querySelector('video');
        if (vid) {
          const applyRatio = function () {
            /* Alleen de verhouding en een rem op uitvergroten doorgeven; de
               CSS (--ds-video-ratio in ds-pages.css) houdt de box binnen het
               scherm. Een harde max-width/max-height in pixels duwde de box
               vroeger buiten beeld zodra de metadata binnenkwam. */
            const m = vid.closest('.ds-overlay__media');
            if (m && vid.videoWidth && vid.videoHeight) {
              m.style.setProperty('--ds-video-ratio', vid.videoWidth / vid.videoHeight);
              m.style.maxWidth = vid.videoWidth + 'px';
            }
          };
          if (vid.readyState >= 1) applyRatio();
          else vid.addEventListener('loadedmetadata', applyRatio, { once: true });
          vid.play().catch(function () {});
        }
      }
    }
    const overlayClose = e.target.closest('[data-ds-overlay-close]');
    if (overlayClose) {
      const ov = overlayClose.closest('.ds-overlay');
      if (ov) { ov.classList.remove('is-open'); const vid = ov.querySelector('video'); if (vid) vid.pause(); }
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.ds-overlay.is-open').forEach(function (ov) {
      ov.classList.remove('is-open'); const vid = ov.querySelector('video'); if (vid) vid.pause();
    });
  });

  /* Licht uit zonder metafield: zoek zelf de uit-foto in de productgalerij (canvas-analyse).
     Zelfde criteria als de offline analyse van 2026-09-03 (96% correct op de gecontroleerde set):
     - geen lampje-icoon rechtsonder (de fotograaf zet dat alleen op aan-foto's),
     - geen maatdiagram (lange witte lijnen), geen lichte achtergrond,
     - hele lamp in beeld (niet afgesneden aan de bovenkant, geen close-up),
     - en daarbinnen het silhouet dat het meest lijkt op de featured (aan-)foto.
     Metafield sierkamer.licht_fotos blijft de vaste keuze; dit is de automatische terugval. */
  const DsLichtZoeker = (function () {
    const W = 400, CACHE = 'ds:lichtuit:';
    function load(url) {
      return new Promise(function (res, rej) {
        const im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function () { res(im); };
        im.onerror = rej;
        im.src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + W;
      });
    }
    function feats(im) {
      const w = W, h = Math.max(4, Math.round(im.naturalHeight * W / im.naturalWidth));
      const cv = document.createElement('canvas'); cv.width = w; cv.height = h;
      const cx = cv.getContext('2d', { willReadFrequently: true });
      cx.drawImage(im, 0, 0, w, h);
      const d = cx.getImageData(0, 0, w, h).data;
      const g = new Float32Array(w * h);
      for (let i = 0, j = 0; i < d.length; i += 4, j++) g[j] = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
      const c = Math.floor(w * 0.1);
      const cornerPx = []; let tl = 0, tr = 0;
      for (let y = 0; y < c; y++) {
        for (let x = 0; x < c; x++) { cornerPx.push(g[y * w + x]); tl += g[y * w + x]; }
        for (let x = w - c; x < w; x++) { cornerPx.push(g[y * w + x]); tr += g[y * w + x]; }
      }
      cornerPx.sort(function (a, b) { return a - b; });
      const bg = cornerPx.length ? cornerPx[Math.floor(cornerPx.length / 2)] : 0;
      const corner = Math.max(tl, tr) / Math.max(1, c * c);
      const bh = Math.floor(h * 0.86);
      let icN = 0, icT = 0;
      for (let y = Math.floor(h * 0.88); y < Math.floor(h * 0.985); y++) {
        for (let x = Math.floor(w * 0.88); x < Math.floor(w * 0.985); x++) { icT++; if (g[y * w + x] > 200) icN++; }
      }
      const icon = icT ? icN / icT : 0;
      const colHot = new Int32Array(w); let maxRow = 0;
      for (let y = 0; y < bh; y++) {
        let rh = 0;
        for (let x = 0; x < w; x++) { if (g[y * w + x] >= 200) { rh++; colHot[x]++; } }
        if (rh / w > maxRow) maxRow = rh / w;
      }
      let maxCol = 0;
      for (let x = 0; x < w; x++) if (colHot[x] / bh > maxCol) maxCol = colHot[x] / bh;
      const lines = Math.max(maxRow, maxCol);
      const thr = bg + 35, S = 24;
      const cells = new Int32Array(S * S), cellN = new Int32Array(S * S);
      let top = h, bot = -1, left = w, right = -1;
      for (let y = 0; y < bh; y++) {
        const sy = Math.floor(y * S / bh);
        for (let x = 0; x < w; x++) {
          const idx = sy * S + Math.floor(x * S / w);
          cellN[idx]++;
          if (g[y * w + x] > thr) {
            cells[idx]++;
            if (y < top) top = y; if (y > bot) bot = y; if (x < left) left = x; if (x > right) right = x;
          }
        }
      }
      const sil = new Uint8Array(S * S);
      for (let i = 0; i < S * S; i++) sil[i] = (cellN[i] && cells[i] / cellN[i] > 0.5) ? 1 : 0;
      if (bot < 0) { top = h; bot = 0; left = w; right = 0; }
      return { corner: corner, icon: icon, lines: lines, top: top / h, bot: bot / h, left: left / w, right: right / w, sil: sil };
    }
    function reject(f, fa) {
      if (f.icon > 0.012) return 'icon';
      if (f.lines > 0.4) return 'diagram';
      if (f.corner > 110) return 'lightbg';
      if (f.top < 0.012 && fa.top > 0.12) return 'topcut';
      if (f.left < 0.01 && f.right > 0.99 && !(fa.left < 0.01 && fa.right > 0.99)) return 'closeup';
      return null;
    }
    function iou(a, b) {
      let i = 0, u = 0;
      for (let k = 0; k < a.length; k++) { if (a[k] && b[k]) i++; if (a[k] || b[k]) u++; }
      return u ? i / u : 0;
    }
    function pick(F) {
      const fa = F[0]; let best = null;
      if (!fa) return null;
      for (let i = 1; i < F.length; i++) {
        const f = F[i];
        if (!f || reject(f, fa)) continue;
        const ba = (f.right - f.left) * (f.bot - f.top), bb = (fa.right - fa.left) * (fa.bot - fa.top);
        let s = iou(f.sil, fa.sil);
        if (bb > 0 && ba / bb > 1.5) s -= 0.3;
        if (!best || s > best.s) best = { i: i, s: s };
      }
      return best;
    }
    function analyse(images) {
      return Promise.all(images.map(function (u) { return load(u).then(feats).catch(function () { return null; }); }))
        .then(function (F) { const b = pick(F); return b ? images[b.i] : null; });
    }
    function find(handle) {
      return fetch('/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p || !p.images || p.images.length < 2) return null;
        const key = CACHE + handle + ':' + p.images.length;
        try {
          const c = localStorage.getItem(key);
          if (c) return c === 'none' ? null : { aan: p.images[0], uit: c };
        } catch (e) {}
        return analyse(p.images).then(function (uit) {
          try { localStorage.setItem(key, uit || 'none'); } catch (e) {}
          return uit ? { aan: p.images[0], uit: uit } : null;
        });
      }).catch(function () { return null; });
    }
    function run(grid) {
      grid.querySelectorAll('.ds-card[data-ds-licht-handle]').forEach(function (card) {
        const handle = card.getAttribute('data-ds-licht-handle');
        card.removeAttribute('data-ds-licht-handle');
        find(handle).then(function (pair) {
          if (!pair) return;
          const media = card.querySelector('.ds-card__media');
          if (!media) return;
          const imgs = media.querySelectorAll('.ds-card__img');
          const after = imgs.length ? imgs[imgs.length - 1] : null;
          ['aan', 'uit'].forEach(function (k) {
            const im = document.createElement('img');
            im.className = 'ds-card__img ds-card__img--' + k;
            im.src = pair[k] + (pair[k].indexOf('?') > -1 ? '&' : '?') + 'width=600';
            im.alt = ''; im.loading = 'lazy'; im.setAttribute('aria-hidden', 'true');
            if (after && after.nextSibling) media.insertBefore(im, after.nextSibling); else media.appendChild(im);
          });
          card.classList.add('has-licht');
        });
      });
    }
    return { run: run, find: find, analyse: analyse };
  })();
  window.DsLichtZoeker = DsLichtZoeker;

  /* Collection: lit toggle — wisselt per lamp tussen de aan- en uit-foto */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-ds-lit-toggle]');
    if (!btn) return;
    const grid = document.querySelector('.ds-colgrid');
    if (!grid) return;
    /* Neutraal (geen class) toont de featured foto = de aan-foto, dus telt als "aan" */
    const wasUnlit = grid.classList.contains('is-unlit');
    if (wasUnlit) {
      grid.classList.remove('is-unlit');
      grid.classList.add('is-lit');
    } else {
      grid.classList.remove('is-lit');
      grid.classList.add('is-unlit');
    }
    const on = !grid.classList.contains('is-unlit');
    btn.classList.toggle('ds-chip--active', on);
    const lbl = btn.querySelector('[data-ds-lit-label]');
    if (lbl) lbl.textContent = on ? __dsT("lit_on", 'Toon uit') : __dsT("lit_off", 'Toon aan');
    /* Kaarten zonder metafield: zoek de uit-foto automatisch */
    if (window.DsLichtZoeker) DsLichtZoeker.run(grid);
  });

  /* Collection: sort */
  document.addEventListener('change', function (e) {
    const sel = e.target.closest('[data-ds-sort]');
    if (!sel) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* Mobiel: bottom sheets (filter/sorteer) + sorteeropties */
  document.addEventListener('click', function (e) {
    const opener = e.target.closest('[data-ds-sheet]');
    if (opener) {
      const el = document.querySelector(opener.getAttribute('data-ds-sheet'));
      if (el) {
        document.querySelectorAll('.ds-sheetwrap').forEach(function (w) { w.hidden = true; });
        el.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }
      return;
    }
    const closer = e.target.closest('[data-ds-sheet-close]');
    if (closer) {
      const wrap = closer.closest('.ds-sheetwrap');
      if (wrap) wrap.hidden = true;
      document.documentElement.style.overflow = '';
      return;
    }
    const sopt = e.target.closest('[data-ds-sort-opt]');
    if (sopt) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sopt.getAttribute('data-ds-sort-opt'));
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }
  });

  /* Mobiel: sticky onderbalk zodra de vaste knop niet in beeld staat */
  function dsUpdateStickyBars() {
    if (document.querySelector('.ds-mbar')) document.documentElement.classList.add('has-ds-mbar');
    document.querySelectorAll('[data-ds-stickybar]').forEach(function (bar) {
      const anchor = document.querySelector(bar.getAttribute('data-ds-stickybar'));
      if (!anchor) return;
      const r = anchor.getBoundingClientRect();
      /* Eén regel: staat de vaste knop in beeld, dan is de balk overbodig;
         staat hij er niet, dan hoort de balk er te zijn. Dus ook meteen bij
         het openen van de pagina, als de knop nog ónder de vouw staat — zo is
         er altijd een bestelknop in beeld, zonder dat je hoeft te scrollen. */
      const visible = r.bottom > 8 && r.top < window.innerHeight - 8;
      bar.classList.toggle('is-shown', !visible);
    });
  }
  window.addEventListener('scroll', dsUpdateStickyBars, { passive: true });
  window.addEventListener('resize', dsUpdateStickyBars);
  document.addEventListener('DOMContentLoaded', function () { setTimeout(dsUpdateStickyBars, 0); });
  /* Ook na 'load': foto's die pas dan hun hoogte krijgen verschuiven het anker. */
  window.addEventListener('load', dsUpdateStickyBars);
  setTimeout(dsUpdateStickyBars, 0);

  /* Mobiel: inklapbare inhoudsopgave op beleidspagina's */
  document.addEventListener('click', function (e) {
    const lbl = e.target.closest('.ds-toc__label');
    if (lbl && window.matchMedia('(max-width: 749px)').matches) {
      const toc = lbl.closest('.ds-toc');
      if (toc) toc.classList.toggle('is-open');
    }
  });

  /* Mobiel: gouden leesvoortgangsbalk onder de sticky header (beleid/artikel) */
  function dsInitReadbar() {
    if (!document.querySelector('.ds-pol-body, .ds-art')) return;
    const hdr = document.querySelector('.ds-hdr');
    if (!hdr || hdr.querySelector('.ds-readbar')) return;
    const bar = document.createElement('div');
    bar.className = 'ds-readbar';
    hdr.appendChild(bar);
    const upd = function () {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      bar.style.width = (max > 0 ? (h.scrollTop / max) * 100 : 0) + '%';
    };
    window.addEventListener('scroll', upd, { passive: true });
    upd();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', dsInitReadbar);
  else dsInitReadbar();

  /* Load more (collection/blog): fetch next page, append grid children */
  function dsAppendPage(btn, html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const sel = btn.getAttribute('data-ds-loadmore');
    const newGrid = doc.querySelector(sel);
    const grid = document.querySelector(sel);
    if (newGrid && grid) {
      Array.from(newGrid.children).forEach(function (c) { grid.appendChild(c); });
      if ((grid.classList.contains('is-lit') || grid.classList.contains('is-unlit')) && window.DsLichtZoeker) DsLichtZoeker.run(grid);
      if (window.__dsFavsMark) window.__dsFavsMark();
    }
    const newBtn = doc.querySelector('[data-ds-loadmore]');
    const wrap = btn.closest('.ds-loadmore');
    const hasNext = !!(newBtn && newBtn.getAttribute('href'));
    if (hasNext) {
      btn.setAttribute('href', newBtn.getAttribute('href'));
      btn.removeAttribute('disabled');
      btn.textContent = btn.dataset.label || __dsT("load_more_lamps", 'Meer lampen laden');
    }
    if (wrap) {
      const count = wrap.querySelector('[data-ds-shown]');
      const fill = wrap.querySelector('.ds-loadmore__fill');
      const shown = document.querySelectorAll(sel + ' > *').length;
      const total = parseInt(wrap.dataset.total || '0', 10);
      if (count) count.textContent = Math.min(shown, total) + __dsT("count_of_sp", ' van ') + total + __dsT('lamps_sp', ' lampen');
      if (fill && total) fill.style.width = Math.min(100, Math.round(shown / total * 100)) + '%';
    }
    if (!hasNext) btn.remove();
    return hasNext;
  }

  /* Terugkeren naar een collectie: eerder bijgeladen pagina's + scrollpositie herstellen.
     Per collectie-URL (incl. filters/sortering) bewaren we in sessionStorage welke
     "meer laden"-URL's geladen zijn en welk product is aangeklikt. */
  const DS_LM_KEY = 'dsLM:' + location.pathname + location.search;
  let dsLoaded = [];
  function dsSaveLM(extra) {
    try {
      const prev = JSON.parse(sessionStorage.getItem(DS_LM_KEY) || '{}');
      const state = Object.assign({}, prev, { urls: dsLoaded, y: window.scrollY }, extra || {});
      sessionStorage.setItem(DS_LM_KEY, JSON.stringify(state));
    } catch (err) {}
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-ds-loadmore]');
    if (!btn) return;
    e.preventDefault();
    const nextUrl = btn.getAttribute('href');
    if (!nextUrl) return;
    btn.setAttribute('disabled', '');
    btn.textContent = __dsT("loading", 'Laden…');
    fetch(nextUrl).then(function (r) { return r.text(); }).then(function (html) {
      dsAppendPage(btn, html);
      dsLoaded.push(nextUrl);
      dsSaveLM();
    }).catch(function () { window.location.href = nextUrl; });
  });

  /* Klik op een kaart in de grid: onthoud welk product en waar het op het scherm stond */
  document.addEventListener('click', function (e) {
    const a = e.target.closest && e.target.closest('#ds-colgrid a[href]');
    if (!a) return;
    const card = a.closest('#ds-colgrid > *');
    dsSaveLM({ href: a.getAttribute('href'), top: card ? card.getBoundingClientRect().top : null });
  }, true);
  window.addEventListener('pagehide', function () {
    if (document.getElementById('ds-colgrid')) dsSaveLM();
  });

  /* "Terug naar collectie" op de productpagina: kwam je van die collectie, ga dan echt
     terug in de geschiedenis (filters, bijgeladen pagina's en positie blijven behouden).
     Anders: markeer dat de collectie na het laden de laatst aangeklikte positie mag herstellen. */
  document.addEventListener('click', function (e) {
    const a = e.target.closest && e.target.closest('.ds-pdp__back');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    let target, ref;
    try { target = new URL(a.href, location.href); } catch (err) { return; }
    try { ref = document.referrer ? new URL(document.referrer) : null; } catch (err) { ref = null; }
    if (ref && ref.origin === location.origin && ref.pathname === target.pathname && history.length > 1) {
      e.preventDefault();
      history.back();
      return;
    }
    try { sessionStorage.setItem('dsLMRestore', target.pathname); } catch (err) {}
  });

  (function dsRestoreLM() {
    const grid = document.getElementById('ds-colgrid');
    if (!grid) return;
    const nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    let isBack = nav.type === 'back_forward';
    try {
      if (sessionStorage.getItem('dsLMRestore') === location.pathname) isBack = true;
      sessionStorage.removeItem('dsLMRestore');
    } catch (err) {}
    let state = null;
    try { state = JSON.parse(sessionStorage.getItem(DS_LM_KEY) || 'null'); } catch (err) {}
    if (!isBack || !state) {
      try { sessionStorage.removeItem(DS_LM_KEY); } catch (err) {}
      return;
    }
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    const urls = Array.isArray(state.urls) ? state.urls : [];
    function scrollBack() {
      let y = state.y || 0;
      if (state.href) {
        const a = grid.querySelector('a[href="' + String(state.href).replace(/"/g, '\\"') + '"]');
        const card = a && a.closest('#ds-colgrid > *');
        if (card && typeof state.top === 'number') y = card.getBoundingClientRect().top + window.scrollY - state.top;
      }
      window.scrollTo(0, Math.max(0, y));
    }
    /* Browser/late layout kan de positie nog verschuiven: ~2s lang corrigeren,
       tenzij de bezoeker zelf al scrolt. */
    function settle() {
      scrollBack();
      let userMoved = false;
      const stop = function () { userMoved = true; };
      ['touchstart', 'wheel', 'keydown', 'mousedown'].forEach(function (ev) { window.addEventListener(ev, stop, { passive: true, once: true }); });
      const until = Date.now() + 2000;
      (function tick() {
        if (userMoved || Date.now() > until) return;
        scrollBack();
        setTimeout(tick, 100);
      })();
      window.addEventListener('load', function () { if (!userMoved) scrollBack(); }, { once: true });
      /* Pop-ups (bv. Klaviyo) die een veld focussen, laten de pagina naar onderen springen */
      const focusUntil = Date.now() + 15000;
      const onFocus = function () {
        if (Date.now() > focusUntil) { document.removeEventListener('focusin', onFocus, true); return; }
        if (userMoved) return;
        setTimeout(scrollBack, 0);
        setTimeout(scrollBack, 60);
        setTimeout(scrollBack, 350);
      };
      document.addEventListener('focusin', onFocus, true);
    }
    let i = 0;
    function next() {
      const btn = document.querySelector('[data-ds-loadmore]');
      if (i >= urls.length || !btn) { dsLoaded = urls.slice(0, i); setTimeout(settle, 0); return; }
      const url = urls[i++];
      btn.setAttribute('disabled', '');
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        btn.setAttribute('href', url);
        dsAppendPage(btn, html);
        next();
      }).catch(function () { dsLoaded = urls.slice(0, i - 1); setTimeout(settle, 0); });
    }
    next();
  })();

  /* Blog chips: client-side tag filter */
  document.addEventListener('click', function (e) {
    const chip = e.target.closest('[data-ds-blogtag]');
    if (!chip) return;
    const tag = chip.getAttribute('data-ds-blogtag');
    document.querySelectorAll('[data-ds-blogtag]').forEach(function (c) { c.classList.toggle('ds-chip--active', c === chip); });
    document.querySelectorAll('.ds-blog-card').forEach(function (card) {
      const tags = (card.getAttribute('data-tags') || '').split('||');
      card.style.display = (!tag || tags.indexOf(tag) !== -1) ? '' : 'none';
    });
  });

  /* Smooth scroll for in-page anchors (e.g. "Lees meer over deze lamp") */
  document.addEventListener('click', function (e) {
    const a = e.target.closest('.ds-sec a[href^="#"]');
    if (!a || a.closest('.ds-toc__list')) return;
    const id = a.getAttribute('href').slice(1);
    if (!id) return;
    const el = document.getElementById(id);
    if (!el) return;
    e.preventDefault();
    window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 96, behavior: 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });

  /* TOC scroll-spy + smooth scroll */
  const toc = document.querySelector('.ds-toc__list');
  if (toc) {
    const links = Array.from(toc.querySelectorAll('a[href^="#"]'));
    const ids = links.map(function (a) { return a.getAttribute('href').slice(1); });
    const spy = function () {
      let cur = '';
      ids.forEach(function (id) {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 180) cur = id;
      });
      links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + cur); });
    };
    window.addEventListener('scroll', spy, { passive: true });
    spy();
    toc.addEventListener('click', function (e) {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.getElementById(a.getAttribute('href').slice(1));
      if (!el) return;
      e.preventDefault();
      window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 130, behavior: 'smooth' });
    });
  }

  /* Besteld-voor-17.00 countdown (Europe/Amsterdam) */
  function amsterdamNow() {
    try {
      return new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' }));
    } catch (e) { return new Date(); }
  }
  function tickCountdown() {
    const els = document.querySelectorAll('[data-ds-countdown]');
    if (!els.length) return;
    const now = amsterdamNow();
    const day = now.getDay(); // 0 zo, 6 za
    const next = new Date(now);
    next.setHours(17, 0, 0, 0);
    if (now >= next) next.setDate(next.getDate() + 1);
    while (next.getDay() === 0 || next.getDay() === 6) next.setDate(next.getDate() + 1);
    const deliverNextDay = !(day === 6 || day === 0 || (day === 5 && now.getHours() >= 17));
    const ms = next - now;
    const h = Math.floor(ms / 3600000);
    const m = Math.floor((ms % 3600000) / 60000);
    els.forEach(function (el) {
      const strong = el.querySelector('strong');
      const suffix = el.querySelector('[data-ds-countdown-suffix]');
      if (deliverNextDay && h < 24) {
        if (strong) strong.textContent = h + ' u ' + String(m).padStart(2, '0') + ' m';
        if (suffix) suffix.textContent = __dsT("tomorrow_home", '→ morgen in huis');
      } else {
        if (strong) strong.textContent = h + ' u ' + String(m).padStart(2, '0') + ' m';
        if (suffix) suffix.textContent = '→ ' + (next.getDay() === 1 ? __dsT("tuesday", 'dinsdag') : __dsT("day_after", 'overmorgen')) + __dsT("in_huis_sp", ' in huis');
      }
    });
  }
  tickCountdown();
  setInterval(tickCountdown, 30000);

  /* Product gallery */
  class DsGallery extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.ds-gallery__stage [data-ds-slide]'));
      this.dots = Array.from(this.querySelectorAll('.ds-gallery__dot'));
      this.thumbs = Array.from(this.querySelectorAll('.ds-gallery__thumb[data-ds-go]'));
      this.counter = this.querySelector('[data-ds-counter]');
      this.label = this.querySelector('[data-ds-medialabel]');
      this.i = 0;
      const self = this;
      const prev = this.querySelector('.ds-gallery__nav--prev');
      const nextB = this.querySelector('.ds-gallery__nav--next');
      if (prev) prev.addEventListener('click', function () { self.go(self.i - 1); });
      if (nextB) nextB.addEventListener('click', function () { self.go(self.i + 1); });
      this.dots.forEach(function (d, idx) { d.addEventListener('click', function () { self.go(idx); }); });
      this.thumbs.forEach(function (t) {
        t.addEventListener('click', function () { self.go(parseInt(t.getAttribute('data-ds-go'), 10)); });
      });
      let sx = null;
      const stage = this.querySelector('.ds-gallery__stage');
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) self.go(self.i + (dx < 0 ? 1 : -1));
        sx = null;
      }, { passive: true });
      this.go(0);
    }
    go(i) {
      const n = this.slides.length;
      if (!n) return;
      this.i = ((i % n) + n) % n;
      const self = this;
      this.slides.forEach(function (s, idx) {
        s.classList.toggle('is-current', idx === self.i);
        if (s.tagName === 'VIDEO') { idx === self.i ? s.play().catch(function () {}) : s.pause(); }
      });
      this.dots.forEach(function (d, idx) { d.classList.toggle('is-current', idx === self.i); });
      this.thumbs.forEach(function (t) {
        t.classList.toggle('is-current', parseInt(t.getAttribute('data-ds-go'), 10) === self.i);
      });
      if (this.counter) this.counter.textContent = (this.i + 1) + ' / ' + n;
      if (this.label) this.label.textContent = this.slides[this.i].getAttribute('data-ds-alt') || '';
    }
  }
  if (!customElements.get('ds-gallery')) customElements.define('ds-gallery', DsGallery);

  /* Buy box: qty stepper + add to cart */
  class DsBuyForm extends HTMLElement {
    connectedCallback() {
      const self = this;
      this.qtyInput = this.querySelector('.ds-qty input');
      this.querySelectorAll('[data-ds-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          const d = parseInt(b.getAttribute('data-ds-qty'), 10);
          const v = Math.max(1, Math.min(9, (parseInt(self.qtyInput.value, 10) || 1) + d));
          self.qtyInput.value = v;
        });
      });
      const btn = this.querySelector('.ds-buy__atc');
      if (btn && !btn.disabled && !btn.classList.contains('ds-buy__atc--notify')) btn.addEventListener('click', function () { self.add(btn); });
    }
    add(btn) {
      const id = this.getAttribute('data-variant-id');
      const qty = parseInt(this.qtyInput && this.qtyInput.value, 10) || 1;
      // De knop bevat op mobiel een icoon en de prijs; alleen het label wisselt.
      const label = btn.querySelector('.ds-buy__atc-label') || btn;
      btn.setAttribute('disabled', '');
      btn.classList.add('is-busy');
      const orig = label.textContent;
      label.textContent = __dsT("adding", 'Toevoegen…');
      fetch((window.routes ? window.routes.cart_add_url : '/cart/add') + '.js'.replace('.js.js', '.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: qty })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart');
        label.textContent = __dsT("added", 'Toegevoegd ✓');
        setTimeout(function () {
          label.textContent = orig;
          btn.classList.remove('is-busy');
          btn.removeAttribute('disabled');
        }, 1600);
      }).catch(function () {
        window.location.href = '/cart/add?id=' + id + '&quantity=' + qty;
      });
    }
  }
  if (!customElements.get('ds-buy-form')) customElements.define('ds-buy-form', DsBuyForm);

  /* Related products via recommendations API */
  class DsRelated extends HTMLElement {
    connectedCallback() {
      const url = this.getAttribute('data-url');
      const self = this;
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('ds-related-items');
        if (inner && inner.children.length) {
          self.querySelector('.ds-related__grid').innerHTML = inner.innerHTML;
          if (window.__dsFavsMark) window.__dsFavsMark();
        } else {
          const sec = self.closest('.ds-related');
          if (sec) sec.style.display = 'none';
        }
      }).catch(function () {});
    }
  }
  if (!customElements.get('ds-related')) customElements.define('ds-related', DsRelated);

  /* Judge.me reviews (parsed from metafield JSON) */
  class DsProductReviews extends HTMLElement {
    connectedCallback() {
      let data = null;
      try { data = JSON.parse(this.querySelector('script[data-ds-reviews]').textContent); } catch (e) {}
      if (!data || !data.reviews || !data.reviews.length) return;
      const list = this.querySelector('[data-ds-review-list]');
      const months = __dsT('months_long', 'januari,februari,maart,april,mei,juni,juli,augustus,september,oktober,november,december').split(',');
      const esc = function (s) { const d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; };
      list.innerHTML = data.reviews.slice(0, 6).map(function (r) {
        const d = new Date(r.created_at);
        const datum = isNaN(d) ? '' : d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear();
        const stars = '★★★★★☆☆☆☆☆'.slice(5 - r.rating, 10 - r.rating);
        const pics = (r.pictures_urls || []).map(function (u) { return '<img src="' + esc(u) + '" alt="' + __dsT('customer_photo', 'Klantfoto') + '" loading="lazy">'; }).join('');
        return '<div class="ds-review"><div class="ds-review__row">' +
          '<span class="ds-review__avatar">' + esc(r.reviewer_initial || (r.reviewer_name || '·')[0]) + '</span>' +
          '<div class="ds-review__body"><div class="ds-review__meta">' +
          '<span class="ds-review__name">' + esc(r.reviewer_name) + '</span>' +
          (r.verified_buyer ? '<span class="ds-review__verified"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 12.5l5 5L20 6.5"></path></svg>Gekochte klant</span>' : '') +
          '<span class="ds-review__date">' + datum + '</span></div>' +
          '<span class="ds-stars" aria-hidden="true">' + stars + '</span>' +
          (r.title ? '<div class="ds-review__title">' + esc(r.title) + '</div>' : '') +
          '<p class="ds-review__text">' + esc(r.body) + '</p>' +
          (pics ? '<div class="ds-review__pics">' + pics + '</div>' : '') +
          '</div></div></div>';
      }).join('');
      const shown = this.querySelector('[data-ds-review-shown]');
      if (shown) shown.textContent = Math.min(6, data.reviews.length) + __dsT("count_of_sp", ' van ') + data.number_of_reviews + __dsT('reviews_sp', ' beoordelingen');
    }
  }
  if (!customElements.get('ds-product-reviews')) customElements.define('ds-product-reviews', DsProductReviews);

  /* Recently viewed: record on product pages, render where <ds-recent> exists */
  const KEY = 'ds:recent';
  function readRecent() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  const marker = document.querySelector('[data-ds-product-handle]');
  if (marker) {
    try {
      const h = marker.getAttribute('data-ds-product-handle');
      let list = readRecent().filter(function (x) { return x !== h; });
      list.unshift(h);
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }
  class DsRecent extends HTMLElement {
    connectedCallback() {
      const exclude = this.getAttribute('data-exclude');
      const handles = readRecent().filter(function (h) { return h !== exclude; }).slice(0, 5);
      if (!handles.length) return;
      const self = this;
      const money = function (cents) {
        const eur = cents / 100;
        const s = eur.toFixed(2).replace('.', ',');
        return '€' + (s.endsWith(',00') ? s.slice(0, -2) + '—' : s);
      };
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        const items = products.filter(Boolean);
        if (!items.length) return;
        self.querySelector('.ds-recent__grid').innerHTML = items.map(function (p) {
          const title = (p.title || '').split('| ').pop().trim();
          const img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=420' : '';
          return '<a href="/products/' + p.handle + '" class="ds-recent__card">' +
            '<span class="ds-recent__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="ds-recent__title">' + title + '</span>' +
            '<span class="ds-recent__price">' + money(p.price) + '</span></a>';
        }).join('');
        self.classList.add('has-items');
      });
    }
  }
  if (!customElements.get('ds-recent')) customElements.define('ds-recent', DsRecent);
})();

/* ---------- Cart page ---------- */
(function () {
  'use strict';
  if (window.__dsCartInit) return;
  window.__dsCartInit = true;

  class DsCart extends HTMLElement {
    connectedCallback() {
      const self = this;
      this.addEventListener('click', function (e) {
        const qtyBtn = e.target.closest('[data-ds-cart-qty]');
        if (qtyBtn) {
          const line = parseInt(qtyBtn.closest('[data-ds-line]').getAttribute('data-ds-line'), 10);
          const cur = parseInt(qtyBtn.closest('[data-ds-line]').getAttribute('data-ds-line-qty'), 10);
          const next = Math.max(0, cur + parseInt(qtyBtn.getAttribute('data-ds-cart-qty'), 10));
          self.change(line, next);
          return;
        }
        const rm = e.target.closest('[data-ds-cart-remove]');
        if (rm) {
          self.change(parseInt(rm.closest('[data-ds-line]').getAttribute('data-ds-line'), 10), 0);
        }
      });
    }
    change(line, quantity) {
      const self = this;
      this.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(function () {
        return fetch(window.location.pathname);
      }).then(function (r) { return r.text(); }).then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('ds-cart');
        if (fresh) self.innerHTML = fresh.innerHTML;
        self.classList.remove('is-busy');
        if (window.__dsFavsMark) window.__dsFavsMark();
        const favs = document.querySelector('ds-cart-favs');
        if (favs && favs.refresh) favs.refresh();
      }).catch(function () { window.location.reload(); });
    }
  }
  if (!customElements.get('ds-cart')) customElements.define('ds-cart', DsCart);

  /* "Nog in je favorieten" suggestions on the cart page */
  class DsCartFavs extends HTMLElement {
    connectedCallback() { this.refresh(); }
    refresh() {
      const self = this;
      let favs = [];
      try { favs = JSON.parse(localStorage.getItem('ds:favs') || '[]'); } catch (e) {}
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        const inCart = cart.items.map(function (i) { return i.handle; });
        const show = favs.filter(function (h) { return inCart.indexOf(h) === -1; }).slice(0, 4);
        if (!show.length) { self.classList.remove('has-items'); return; }
        return Promise.all(show.map(function (h) {
          return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
        })).then(function (products) {
          const items = products.filter(Boolean);
          if (!items.length) { self.classList.remove('has-items'); return; }
          const money = function (c) { return '€' + (c / 100).toFixed(2).replace('.', ','); };
          const esc = function (s) { const d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; };
          self.querySelector('.ds-cartfavs__grid').innerHTML = items.map(function (p) {
            const title = esc((p.title || '').split('| ').pop().trim());
            const img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
            const v = p.variants && p.variants[0];
            const cta = (p.available && v && p.variants.length === 1)
              ? '<add-to-cart class="ds-card__cta" role="button" tabindex="0" data-variant-id="' + v.id + '">In winkelmandje</add-to-cart>'
              : '<a href="/products/' + p.handle + '" class="ds-card__cta">' + __dsT('view_lamp', 'Bekijk de lamp') + '</a>';
            return '<div class="ds-cartfavs__card">' +
              '<a href="/products/' + p.handle + '">' + (img ? '<img src="' + img + '" alt="' + title + '" loading="lazy">' : '') + '</a>' +
              '<a href="/products/' + p.handle + '" class="ds-cartfavs__name">' + title + '</a>' +
              '<div class="ds-cartfavs__price">' + money(p.price) + '</div>' + cta + '</div>';
          }).join('');
          self.classList.add('has-items');
        });
      }).catch(function () {});
    }
  }
  if (!customElements.get('ds-cart-favs')) customElements.define('ds-cart-favs', DsCartFavs);
})();

/* ---------- Product specs: "Label: waarde" list -> two-column spec table (per design) ---------- */
(function () {
  'use strict';
  if (window.__dsSpecsInit) return;
  window.__dsSpecsInit = true;
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
  function transform() {
    document.querySelectorAll('.ds-spec-list').forEach(function (el) {
      var lis = el.querySelectorAll('li');
      if (!lis.length) return;
      var rows = Array.from(lis).map(function (li) {
        var t = li.textContent.trim();
        var i = t.indexOf(':');
        return i > -1 ? [t.slice(0, i).trim(), t.slice(i + 1).trim()] : [t, ''];
      }).filter(function (r) { return r[0]; });
      var half = Math.ceil(rows.length / 2);
      var col = function (arr) {
        return '<div>' + arr.map(function (r) {
          return '<div class="ds-spec-row"><span>' + esc(r[0]) + '</span><span>' + esc(r[1]) + '</span></div>';
        }).join('') + '</div>';
      };
      el.innerHTML = '<div class="ds-spec-grid">' + col(rows.slice(0, half)) + col(rows.slice(half)) + '</div>';
      el.classList.add('is-table');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', transform);
  else transform();
})();

/* FAQ-pagina: accordeons (één vraag en één onderwerp tegelijk open) */
(function () {
  if (window.__dsFaqInit) return;
  window.__dsFaqInit = true;
  document.addEventListener('click', function (e) {
    const qBtn = e.target.closest('[data-ds-faq-q]');
    if (qBtn) {
      const item = qBtn.closest('.ds-faq__item');
      if (!item) return;
      const wasOpen = item.classList.contains('is-open');
      document.querySelectorAll('.ds-faq__item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
      if (!wasOpen) item.classList.add('is-open');
      return;
    }
    const cBtn = e.target.closest('[data-ds-faq-cat]');
    if (cBtn) {
      const card = cBtn.closest('.ds-faqcat');
      if (!card) return;
      const wasOpen = card.classList.contains('is-open');
      document.querySelectorAll('.ds-faqcat.is-open').forEach(function (c) { c.classList.remove('is-open'); });
      document.querySelectorAll('.ds-faq__item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
      if (!wasOpen) card.classList.add('is-open');
    }
  });
})();

/* Kennisbank artikel: inhoudsopgave uit h2's + leesbalk ook op desktop */
(function () {
  if (window.__dsArtInit) return;
  window.__dsArtInit = true;
  function init() {
    const body = document.querySelector('.ds-artbody');
    if (!body) return;
    const hdr = document.querySelector('.ds-hdr');
    if (hdr) hdr.classList.add('has-readbar-desktop');
    const toc = document.querySelector('[data-ds-arttoc]');
    const list = document.querySelector('[data-ds-arttoc-list]');
    if (!toc || !list) return;
    const heads = Array.from(body.querySelectorAll('h2'));
    if (heads.length < 2) return;
    const arrow = '<span style="display:flex;justify-content:flex-end;"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 5v13"></path><path d="M6 12l6 6 6-6"></path></svg></span>';
    heads.forEach(function (h, i) {
      if (!h.id) {
        h.id = 'sectie-' + (i + 1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9à-ÿ]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
      }
      const a = document.createElement('a');
      a.href = '#' + h.id;
      a.innerHTML = '<span>' + h.textContent.trim().replace(/</g, '&lt;') + '</span>' + arrow;
      list.appendChild(a);
    });
    toc.hidden = false;
    const head = toc.querySelector('.ds-arttoc__head');
    if (head) head.addEventListener('click', function () {
      if (window.matchMedia('(max-width: 749px)').matches) toc.classList.toggle('is-open');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

